import { render } from "./BrowserDownload.vue?vue&type=template&id=5a9eb2c2"
import script from "./BrowserDownload.vue?vue&type=script&lang=js"
export * from "./BrowserDownload.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__